/* eslint import/no-unresolved:0, import/no-duplicates:0, import/no-extraneous-dependencies: 0 */
// the modulepreload polyfill causes shenanigans with the eslint import plugin
import React from 'react';
import ReactDOM from 'react-dom';
import EmbeddedInitiateCheckout from './EmbeddedInitiateCheckout';
import Providers from '~/components/Providers';
import 'vite/modulepreload-polyfill';

const urlParams = new URLSearchParams(window.location.search);
const promoCode = urlParams.get('promo_code');
const trialCode = urlParams.get('trial_code');
const billingCadence = urlParams.get('billing_cadence') || 'monthly';

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <EmbeddedInitiateCheckout
        promoCode={promoCode}
        trialCode={trialCode}
        billingCadence={billingCadence}
      />
    </Providers>
  </React.StrictMode>,
  document.getElementById('initiate-checkout-app'),
);
